module.exports = __webpack_public_path__ + "img/image10.d34fcd3e.png";